import { useMemo } from "react"
import { useQuery } from "urql"

import { useGetCustomerCompanyDetails } from "./useGetCustomerCompanyDetails"

import "@/screens/Companies/edit/components/preferences/graphql/shipFromPreference.query"

import {
  type CompanyPreferredMeasurementSystemEnum,
  ShipFromPreferenceListDocument,
  type ShipFromPreferenceListQuery,
} from "@/graphql/codegen/graphql"

interface UseGetDeliveryDateLineDefaultsReturn {
  preferredShipFromLocationId: string | null
  preferredMeasurementSystem: CompanyPreferredMeasurementSystemEnum | undefined
}

export const useGetDeliveryDateLineDefaults = (
  companyId: string,
  shipToLocationId: string
): UseGetDeliveryDateLineDefaultsReturn => {
  const { company } = useGetCustomerCompanyDetails(companyId, shipToLocationId)

  const [{ data }] = useQuery<ShipFromPreferenceListQuery>({
    query: ShipFromPreferenceListDocument,
    variables: { input: { filter: { shipToLocationId } } },
    pause: !shipToLocationId,
  })

  const output = data?.shipFromPreference.list

  const preferredShipFromLocationId = useMemo(() => {
    if (output?.__typename !== "ShipFromPreferenceListSuccess") return null
    return output.shipFromPreferences.find((preference) => preference.isPreferred)?.shipFromWarehouseId ?? null
  }, [output])

  return { preferredShipFromLocationId, preferredMeasurementSystem: company?.preferredMeasurementSystem }
}
